export const UPDATE_ORGANIZATION = "UPDATE_ORGANIZATION";
export const UPDATE_ORGANIZATION_ERROR = "UPDATE_ORGANIZATION_ERROR";
export const POST_NEW_ORGANIZATION = "POST_NEW_ORGANIZATIONS";
export const POST_PRACTICE_INFO = "POST_PRACTICE_INFO";
export const SET_PRACTICE_INFO = "SET_PRACTICE_INFO";
export const GET_PRACTICE_INFO = "GET_PRACTICE_INFO";
export const UPDATE_PRACTICE_INFO = "UPDATE_PRACTICE_INFO";
export const SET_ORGANIZATION_DATA = "SET_ORGANIZATION_DATA";
export const EDIT_FORWARDING_PHONE_NUMBER = "EDIT_FORWARDING_PHONE_NUMBER";
